module.exports = __webpack_public_path__ + "img/red-car-remove.f23265a1.svg";